import React, { Component } from 'react'
import { withRouter } from 'react-router'
import { connect } from 'react-redux'
import {
  getTranslation,
  getLanguageCode,
  getIsTemplatesUSer,
} from '@/store/getters'
import { toggleToaster, showAlert, closeAlert, deleteMagazine, duplicateMagazine } from '@/store/actions'
import { getFormatedDate } from '@/constants'

import style from './styles.scss'

/** Components */
import MagazineCover from '../MagazineCover'
import MagazineEdit from '../MagazineEdit'
import MagazineTransfer from '../MagazineTransfer'
import MagazineThumbnail from '../MagazineThumbnail'

import EmbedMagazine from '@/components/EmbedMagazine'
import { PopOver } from '@/components/commons/PopOver'

class MagazineCard extends Component {
  state = {
    showMenu: false,
    showEmbed: false,
    showEdit: false,
    showTransfer: false,
    showThumbnail: false,
    showDelete: false,
  }

  componentDidUpdate(_, prevState) {
    const { showEdit, showTransfer } = this.state

    if (prevState.showEdit !== showEdit || prevState.showTransfer !== showTransfer) {
      this.setState({ showMenu: false })
    }
  }

  handleDuplicate = () => {
    const { magazine, translation, toggleToaster, duplicateMagazine } = this.props
    const { id, id_usuario, id_domain, title, description, properties } = magazine

    this.setState({ showMenu: false })
    duplicateMagazine(id, { id_usuario, id_domain, title, description, properties })
    toggleToaster({
      isVisible: true,
      message: translation('general-magazine-duplicate-success'),
      position: 'top-right',
      type: 'success'
    })
  }

  handleEdit = () => {
    this.setState({ showMenu: false })
    this.setState({ showEdit: true })
  }

  handleTransfer = () => {
    this.setState({ showMenu: false })
    this.setState({ showTransfer: true })
  }

  handleEmbed = () => {
    this.setState({ showMenu: false })
    this.setState({ showEmbed: true })
  }

  handleDelete = () => {
    const { translation, showAlert, toggleToaster, closeAlert, deleteMagazine } = this.props
    const { id } = this.props.magazine

    showAlert({
      title: translation('general-delete-title'),
      message: translation('general-magazine-delete-success'),
      hasCancel: true,
      type: 'error',
      callback: () => {
        closeAlert()
        deleteMagazine(id)
        toggleToaster({
          isVisible: true,
          message: translation('general-magazine-delete-success'),
          position: 'top-right',
          type: 'success'
        })
      }
    })
  }

  getDate = date => getFormatedDate(date, false, this.props.localeCode)

  render() {
    const { showMenu, showEmbed, showEdit, showThumbnail, showTransfer } = this.state
    const { translation, magazine } = this.props

    return (
      <React.Fragment>
        <div className={'ba-card ba-no-padding ba-200'}>
          <div className={"ba-top " + style['ba-display']}>
            <p className={'ba-montserrat-700 ba-color-white1 ' + style['hover']}
              onClick={() => window.open(`/magazines/${magazine.id}`, '_blank')}>
              {translation('general-open-editor')}
            </p>
            <picture className={style['ba-img']}>
              <MagazineCover magazineID={magazine.id} />
            </picture>

            <div className={style['ba-absolute']}>
              <span className={'ba-montserrat-700 ba-color-white1 ' + style['ba-title']}>
                {magazine.title !== "\0" ? magazine.title : translation("magazine-card-untitled")}
              </span>
              <span className={'ba-color-white1 ' + style['ba-subtitle']}>
                {`${translation('general-created')}: ${this.getDate(
                  magazine.created_at || magazine.updated_at
                )}`}
              </span>
            </div>
          </div>

          <div className={"ba-content ba-jc-fe ba-flex ba-gp-04 ba-mg-b-1 " + style['ba-relative']}>
            <button className={'ba-btn ba-btn-normal ba-sm ba-rounded ' + style['ba-mg-0']}
              ba-tooltip-position='top'
              ba-tooltip-title={translation('general-open-browser')}
              onClick={() => window.open(`/publish/${magazine.id}`, '_blank')}>
              <builderall-icon code='eye' />
            </button>
            <button className={'ba-btn ba-btn-normal ba-sm ba-rounded ' + style['ba-mg-0']}
              ba-tooltip-position='top'
              ba-tooltip-title={translation('general-open-editor')}
              onClick={() => window.open(`/magazines/${magazine.id}`, '_blank')}>
              <builderall-icon code='edit' />
            </button>
            <button className={'ba-btn ba-btn-normal ba-sm ba-rounded ' + style['ba-mg-0']}
              ba-tooltip-position='top'
              ba-tooltip-title={translation('general-edit-information')}
              onClick={this.handleEdit}>
              <builderall-icon code='5270' />
            </button>
            <button className={'ba-btn ba-sm ba-rounded ' + (showMenu ? 'ba-blue ' : 'ba-btn-normal ') + style['ba-mg-0']}
              ba-tooltip-position='top'
              ba-tooltip-title={translation('general-settings')}
              onClick={() => this.setState({ showMenu: true })} >
              <builderall-icon code='settings' />
            </button>
            {showMenu &&
              <PopOver
                className={'ba-card ba-200 ' + style['ba-absolute']}
                hidePopover={() => this.setState({ showMenu: false })}
              >
                <ul className='ba-w-100'>
                  <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                    onClick={this.handleDuplicate}
                  >
                    <builderall-icon code='f5ff' class='ba-sm-icon' />
                    <span className='ba-mg-l-1'>
                      {translation('general-duplicate')}
                    </span>
                  </li>
                  <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                    onClick={this.handleTransfer}
                  >
                    <builderall-icon code='bf58' class='ba-sm-icon' />
                    <span className='ba-mg-l-1'>
                      {translation('transfer')}
                    </span>
                  </li>
                  <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                    onClick={this.handleEmbed}
                  >
                    <builderall-icon code='5399' class='ba-sm-icon' />
                    <span className='ba-mg-l-1'>
                      {translation('action-embed')}
                    </span>
                  </li>
                  <li className='ba-flex ba-ai-center ba-color-hover-blue1 ba-bg-hover-blue14 ba-pd-1'
                    onClick={this.handleDelete}
                  >
                    <builderall-icon code='trash' class='ba-sm-icon' />
                    <span className='ba-mg-l-1'>
                      {translation('general-delete')}
                    </span>
                  </li>
                </ul>
              </PopOver>
            }
          </div>
        </div>

        <EmbedMagazine
          show={showEmbed}
          id_magazine={magazine.id}
          handleClose={() => this.setState({ showEmbed: false })}
        />
        <MagazineEdit
          show={showEdit}
          magazine={magazine}
          handleClose={() => this.setState({ showEdit: false })}
        />
        <MagazineThumbnail
          show={showThumbnail}
          magazine={magazine}
          handleClose={() => this.setState({ showThumbnail: false })}
        />
        <MagazineTransfer
          show={showTransfer}
          magazine={magazine}
          handleClose={() => this.setState({ showTransfer: false })}
        />
      </React.Fragment>
    )
  }
}

const mapStateToProps = state => {
  const localeCode = getLanguageCode(state)
  const translation = getTranslation(state)
  const templateCreator = getIsTemplatesUSer(state)
  return { translation, localeCode, templateCreator }
}

export default withRouter(connect(
  mapStateToProps,
  {
    toggleToaster,
    showAlert,
    closeAlert,
    deleteMagazine,
    duplicateMagazine
  }
)(MagazineCard))



// WEBPACK FOOTER //
// ./src/pages/Dashboard/components/MagazineCard/index.js